import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { PbsCookieNames, ReferralType } from "../../models";
export var useCookieStoreInfo = function useCookieStoreInfo() {
  var _useState = useState({
      type: ReferralType.None,
      productListType: 'Personal'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    cookieInfo = _useState2[0],
    setCookieInfo = _useState2[1];
  useEffect(function () {
    var pbsOwnerCookie = Cookies.get(PbsCookieNames.PBS_OWNER);
    var ecrefCookie = Cookies.get(PbsCookieNames.ECREF);
    if (pbsOwnerCookie) {
      setCookieInfo({
        owner: pbsOwnerCookie,
        productListType: 'Personal',
        type: ReferralType.PBS
      });
      return;
    }
    if (ecrefCookie) {
      setCookieInfo({
        owner: ecrefCookie,
        productListType: 'Personal',
        type: ReferralType.ECREF
      });
    }
  }, []);
  return cookieInfo;
};